import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gerar-faq',
  templateUrl: './gerar-faq.component.html',
  styleUrls: ['./gerar-faq.component.css']
})
export class GerarFAQComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  isValid: boolean = true; 
  changeValue(valid: boolean) {
  this.isValid = valid;
     } 
}
